<dynamic-table
  [form]="form"
  [selectable]="selectable"
  [rowTemplate]="rowTemplate"
  [columns]="columns"
  [addEntityLabel]="'Add employee' | translate"
  [entityLimit]="employeeLimit"
  [addEntityDisabledTooltipLabel]="
    'You can only add up to [employeeLimit] employees' | translate | translationParams: { employeeLimit }
  "
  (removeRow)="removeEmployee($event)"
  (addRow)="addEmployee()"
  (selectAllToggle)="syncAllEmailsValidity()"
  (rowToggle)="syncEmailValidity($event)"
>
  <ng-template #rowTemplate let-row>
    <sb-form-field
      [showLabel]="false"
      [noPadding]="true"
      [fullWidth]="true"
      [control]="row.get('first_name')"
      [errorWhen]="['touched']"
      [sbTooltip]="row.get('first_name').errors | firstError"
      [sbTooltipDisabled]="row.get('first_name').valid || row.get('first_name').pristine"
      [hideErrorMessages]="true"
    >
      <input
        sbInput
        #firstNameInput
        name="first_name"
        [formControl]="row.get('first_name')"
        [placeholder]="'First name' | translate"
      />
    </sb-form-field>
    <sb-form-field
      [showLabel]="false"
      [noPadding]="true"
      [fullWidth]="true"
      [control]="row.get('last_name')"
      [errorWhen]="['touched']"
      [sbTooltip]="row.get('last_name').errors | firstError"
      [sbTooltipDisabled]="row.get('last_name').valid || row.get('last_name').pristine"
      [hideErrorMessages]="true"
    >
      <input sbInput name="last_name" [formControl]="row.get('last_name')" [placeholder]="'Last name' | translate" />
    </sb-form-field>
    @if (showEmail) {
      <sb-form-field
        [showLabel]="false"
        [noPadding]="true"
        [fullWidth]="true"
        [control]="row.get('email')"
        [errorWhen]="['touched']"
        [sbTooltip]="row.get('email').errors | firstError"
        [sbTooltipDisabled]="row.get('email').valid || row.get('email').pristine"
        [hideErrorMessages]="true"
      >
        <input sbInput name="email" [formControl]="row.get('email')" />
      </sb-form-field>
    }
    <sb-form-field
      [showLabel]="false"
      [noPadding]="true"
      [fullWidth]="true"
      [control]="row.get('Team')"
      [errorWhen]="['touched']"
      [sbTooltip]="row.get('Team').errors | firstError"
      [sbTooltipDisabled]="row.get('Team').valid || row.get('Team').pristine"
      [hideErrorMessages]="true"
    >
      <select sbInput name="Team" [formControl]="row.get('Team')">
        @for (team of teams$ | async; track team.id) {
          <option [value]="team.id">{{ team.name }}</option>
        }
      </select>
    </sb-form-field>
  </ng-template>
</dynamic-table>
